import { createFileRoute, redirect } from '@tanstack/react-router';
import { tokenManager } from '@/shared/lib/storage';

/**
 * ルートパス `/` の定義
 *
 * App層の責務:
 * - URLパス `/` の認証状態に応じたリダイレクト
 * - 認証済み → `/home` へリダイレクト
 * - 未認証 → `/login` へリダイレクト
 * - TanStack Router のファイルベースルーティング
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    // 認証済み → /home にリダイレクト
    if (tokenManager.isAuthenticated()) {
      throw redirect({ to: '/home' });
    }
    // 未認証 → /login にリダイレクト
    throw redirect({ to: '/login' });
  },
});
